import { useEffect, useState } from "react";

export const useChatSocket = (socket, chatId, userdata, onNewMessage, onTyping, onNewChat) => {
  const [uniqueMessageIds, setUniqueMessageIds] = useState(new Set());
  const [messagesArray, setMessagesArray] = useState([]);
  const [flag, setFlag] = useState("");

  useEffect(() => {
    if (!socket) {
      console.warn("Socket not available");
      return;
    }

    if (!socket.connected) {
      console.warn("Socket not connected, attempting to connect...");
      socket.connect();
    }

    const handleMessage = (newMessage) => {
      console.log("Received message from socket:", newMessage);
      console.log("Current ChatId:", chatId);
      
      const normalizedMessage = {
        ...newMessage,
        _id: newMessage._id || newMessage.message_id || newMessage.id,
        user: newMessage.user || newMessage.user_detail?.[0],
      };
      
      if (!normalizedMessage || !normalizedMessage._id) {
        console.warn("Invalid message received:", normalizedMessage);
        return;
      }
      
      setUniqueMessageIds((prevUniqueIds) => {
        if (prevUniqueIds.has(normalizedMessage._id)) {
          console.log("Duplicate message ignored:", normalizedMessage._id);
          return prevUniqueIds;
        }
        return new Set(prevUniqueIds).add(normalizedMessage._id);
      });
      
      setMessagesArray((prevMessages) => {
        if (prevMessages.some(m => m._id === normalizedMessage._id)) {
          console.log("Duplicate message in array, ignoring");
          return prevMessages;
        }
        
        const filtered = prevMessages.filter(
          (m) => !(m._id?.startsWith("temp_") && m.message === normalizedMessage.message && (m.sender_id === normalizedMessage.sender_id || m.user?._id === normalizedMessage.user?._id))
        );
        
        const updated = [...filtered, normalizedMessage];
        console.log("Adding message to array. Total messages:", updated.length);
        return updated;
      });
      
      if (onNewMessage) {
        onNewMessage(normalizedMessage);
      }
    };

    let typingTimeout;
    const handleTyping = (data) => {
      clearTimeout(typingTimeout);
      setFlag(data.status);
      typingTimeout = setTimeout(() => {
        setFlag("");
      }, 2000);
      if (onTyping) {
        onTyping(data);
      }
    };

    const handleNewChat = (response) => {
      if (onNewChat) {
        onNewChat(response);
      }
    };

    socket.on("message", handleMessage);
    socket.on("typing", handleTyping);
    socket.on("new_chat", handleNewChat);
  

    socket.on("connect", () => {

    });

    socket.on("disconnect", () => {
      console.warn("Socket disconnected");
    });

    socket.on("connect_error", (error) => {
      console.error("Socket connection error:", error);
    });

    return () => {
      socket.off("message", handleMessage);
      socket.off("typing", handleTyping);
      socket.off("new_chat", handleNewChat);
      socket.off("connect");
      socket.off("disconnect");
      socket.off("connect_error");
      if (typingTimeout) clearTimeout(typingTimeout);
    };
  }, [socket, chatId, onNewMessage, onTyping, onNewChat]);

  return { messagesArray, flag, setMessagesArray };
};

